module.exports = __webpack_public_path__ + "images/duplex-icon-51bfdd97eb4593a1b31a2f5810e8e35a.svg";